export default "__VITE_ASSET__BiMDh9pc__"